import { z } from 'zod'

export const SearchSchema = z.object({
  cityId: z.number().optional(),
  continentId: z.number().optional(),
  countryId: z.number().optional(),
  isHot: z.number().optional(),
  isRecommended: z.number().optional(),
  scenicAreaId: z.number().optional(),
  status: z.number().optional(),
  page: z.number().default(1),
  size: z.number().default(10),
})

export type Search = z.infer<typeof SearchSchema>
